import functions from "./functions.js";
import { Select2 } from "./components/select2";

$(() => {
    booking.init();
});

const booking = {
    $form: null,
    form: null,
    calc: [],
    totalAmount: null,
    params: {},

    init() {

        this.$form = $('.booking-form');
        this.form = this.$form[0];

        if (! this.$form.length) {
            return;
        }

        this.checkPaymentType();
        this.prepareForBooking();
        this.getGuestsData();
        this.getPlaceFromId();

        if ( ! booking.calc.length) {
            return;
        }

        const $placeFromId = $('[name="placeFromId"]'); 
        if ($placeFromId.length) {
            let placeFromData = $placeFromId.attr('data-data');
            placeFromData = placeFromData ? JSON.parse(placeFromData) : null;
    
            this.$form.on('change', '[name="placeFromId"]', e => {
                const $target = $(e.currentTarget);
                let placeFromId = $target.val();

                booking.selectionCalculate($target);

                booking.calc.forEach(calc => {
                    if (calc.itemDefinitionId.id == 35) {
                        calc.placeFromId = calc.placeReturnId = placeFromId;
                    }
                });

                functions.setCookie('placeFromId', placeFromId, 0.08);
            });
        }

        this.$form.on('change', 'input[type="checkbox"], input[type="radio"]', function (e) {
            let $calcItem = $(e.currentTarget).closest('.calc-item');
            let $quantity = $calcItem.find('[name=quantity]');
            let value = $quantity.length ? +$quantity.val() : 1;
            let checked = $(e.currentTarget).is(':checked') ? 1 : 0;

            if ($quantity) {
                if (checked && !value) {
                    $quantity.prop('value', 1);
                } else if (! checked && value) {
                    $quantity.prop('value', 0);
                }
            }

            booking.calculate($(e.currentTarget));
        });

        booking.$payment = $('.payment-details');

        this.$form.on('submit', e => {
            //e.preventDefault();
            //e.stopPropagation();

            this.submit();
        });

        this.$form.on('change', e => {
            const $target = $(e.currentTarget);
            const data = functions.getFormData($target);

            let guestsData = {};

            const guestsDataKeys = [
                'guestFirstName',
                'guestLastName',
                'birthDateDay',
                'birthDateMonth',
                'birthDateYear',
                'gender',
            ];
            /*const holderDataKeys = [
                'firstName',
                'lastName',
                'email',
                'phone',
                'address',
            ];*/

            for (const [key, value] of Object.entries(data)) {
                // ako key starts with guestsDataKey, spremi u JSON za cookie guestsData
                let hasKey = guestsDataKeys.find(guestDataKey => {
                    return key.startsWith(guestDataKey);
                });
                if(hasKey) {
                    let calcIds = value.split(',');

                    calcIds.forEach((itemValue, calcId) => {
                        if(! guestsData[calcId]) guestsData[calcId] = {};
                        guestsData[calcId][key] = itemValue;
                    });
                    //guestsData[key] = value;
                }

                // ako je key == holderDataKey, spremi u JSON cookie holderData

                //key == 'placeFromId' && functions.setCookie('placeFromId', value, 0.08);

            }
            
            //functions.setCookie('guestsData', null, -1);
            // cookie neka se cleara za tjedan dana
            functions.setCookie('guestsData', JSON.stringify(guestsData), 7);
        });

        const $partnerCodeSuccess = $(".partnerCodeSuccess");
        const $partnerCodeError = $(".partnerCodeError");

        if($('#partnerCodeApply').length) {
            $('#partnerCodeApply').on('click', function (e) {
                e.preventDefault();

                let params = functions.getUrlData(false);
                params.partnerCode = $("[name='partnerCode']").val();
                params.language = functions.getLang();

                $partnerCodeSuccess.addClass('d-none');
                $partnerCodeError.addClass('d-none');

                //$('button[type="submit"]').attr('disabled', 'disabled');

                $.get('/services/booking_form_cart/', $.param(params)).then(response => {
                    response = JSON.parse(response);
                    if (response.status) {
                        $('.cart-booking').replaceWith(response.html);
                        booking.prepareForBooking();
                        $partnerCodeSuccess.removeClass('d-none');
                        $partnerCodeError.addClass('d-none');
                    } else {
                        $partnerCodeSuccess.addClass('d-none');
                        $partnerCodeError.removeClass('d-none');
                    }

                    // LOZAD
                    window.observer.observe();

                    $(".select2:not([data-select2-id])").each((i, elem) => {
                        elem._select2 = new Select2(elem);
                    });

                    booking.getGuestsData();
                    booking.getPlaceFromId();
                });
            });
        }
        
    },
    selectionCalculate($target) {
        const value = +$target.val();
        let dataItem = null;
        let calc = null;
        const data = $target.attr('data-data') ? JSON.parse($target.attr('data-data')) : [];

        if(data) {
            dataItem = data.filter(item => item.id == value )[0];
            calc = dataItem.calc;

            let dataIds = [];
            data.forEach(dataItem => {
                dataIds.push(dataItem.itemUniqueId);
            });
            booking.calc = booking.calc.filter(calcItem => {
                return ! dataIds.includes(calcItem.id);
            });
        }

        $target.attr('data-calc', calc);

        if(calc) {
            let item = JSON.parse(calc);
            item.inCalc = item.isOptional ? 0 : 1;

            $target.attr('data-id', item.id);

            booking.calc.push(item);

        }

        booking.calculate($target);
    },
    getGuestsData() {
        let guestsData = functions.getCookie('guestsData');
        guestsData = guestsData ? JSON.parse(guestsData) : {};

        for (const [index, guestData] of Object.entries(guestsData)) {
            const calcId = +index + 1;

            for (const [key, value] of Object.entries(guestData)) {
                $('[name="' + key + '"][data-calcId="' + calcId + '"]').val(value).trigger('change');
            }
        }
    },
    getPlaceFromId() {
        let placeFromId = functions.getCookie('placeFromId');
        placeFromId && $('[name="placeFromId"]').val(+placeFromId).trigger('change');
    },
    checkPaymentType() {
        // BOOKING PAYMENT TYPE CHECKBOX
        if($('[name="paymentType"]').length) {
            checkPaymentType();
            $('[name="paymentType"]').on('change', e => {
                checkPaymentType();
            });

            function checkPaymentType() {
                $('[name="paymentType"]').each((index, item) => {
                    const $item = $(item);
                    const id = $item.attr('id');
                    $('[for=' + id + ']').find('[id='  + id + ']').prop('checked', $item.is(':checked'));
                });
            }
        }
    },
    prepareForBooking() {

        booking.calc = [];

        $("*[data-calc]").each(function (index) {
            let item = JSON.parse($(this).attr('data-calc'));
            item.inCalc = item.isOptional ? 0 : 1;
            booking.calc.push(item);
        });

        // calc items by unique itemId
        /*booking.calc = booking.calc.filter((value, index, self) => {
            return self.findIndex(v => v.id === value.id) === index;
        });*/

        if ( ! booking.calc.length) {
            return;
        }

        this.total();
    },
    itemTotal(item) {
        let itemTotal = 0.00;

        if (item.paymentTypeId.key) {

            if ($.inArray(item.paymentTypeId.key, ['perPerson', 'perPersonPerDay', 'perPersonPerWeek', 'Once']) > -1) {
                itemTotal = +item.quantity * +item.price;
            } else {
                itemTotal = +item.price;
            }
        } else {
            itemTotal = +item.quantity * +item.price;
        }

        return itemTotal;
    },
    total() {
        booking.totalAmount = 0.00;
        let cartItemsCalc = [];

        $.each(booking.calc, function (key, calc) {
            if (!calc.onSpot && calc.inCalc) {

                let totalAmount = booking.itemTotal(calc);

                if (! cartItemsCalc[calc.calcId]) {
                    cartItemsCalc[calc.calcId] = [];
                }

                cartItemsCalc[calc.calcId].push({totalAmount : totalAmount});

                booking.totalAmount += totalAmount;
            }
        });

        Object.keys(cartItemsCalc).forEach(key => {

            let items = cartItemsCalc[key];
            let $calc = $('.calc-' + key);
            let cartItemTotal = 0;

            $.each(items, function (key2, item) {
                cartItemTotal += item.totalAmount;
            });

            const $cartItemTotal = $calc.find('.cart-item-total');
            const currencySymbol = $cartItemTotal.attr('data-currencySymbol');
            $cartItemTotal.html(currencySymbol + ' ' + functions.formatMoney(cartItemTotal, 2, ',', '.'));
        });

        $('.cart-total-amount').html(functions.formatMoney(booking.totalAmount, 2, ',', '.'));
        
        const advancePaymentPercent = $('[data-advancePaymentPercent]').attr('data-advancepaymentpercent');
        const advance = booking.totalAmount * (advancePaymentPercent / 100);
        const rest = booking.totalAmount - advance;

        $('.advance').html(functions.formatMoney(advance, 2, ',', '.'));
        $('.rest').html(functions.formatMoney(rest, 2, ',', '.'));
    },
    calculate($elem) {
        let $calcItem = $elem.closest('.calc-item');
        
        let $checkbox = $calcItem.find('input[type="checkbox"]');
        let checked = $checkbox.is(':checked') ? 1 : 0;
        let id = $checkbox.attr('id');
        id = id ? id.split('-')[0] : id;
        let calcData = $calcItem.attr('data-calc') ? JSON.parse($calcItem.attr('data-calc')) : null;

        let $quantity = $calcItem.find('select.quantity:visible');
        let quantity = null;

        if ($quantity.length) {
            quantity = +$quantity.val();
        }

        $.each(booking.calc, function (key, calc) {
            //if (calc.id == id) {
            if (calcData && calc.id == id && calcData.calcId == calc.calcId) {

                if (quantity == null) {
                    quantity = booking.calc[key].quantity;
                }

                booking.calc[key].inCalc = checked;
                booking.calc[key].quantity = (quantity || 0);
                booking.calc[key].total = booking.itemTotal(booking.calc[key]);

                let $itemTotalAmount = $calcItem.find('.item-total-amount');
                let currencySymbol = $itemTotalAmount.attr('data-currencysymbol');
                $itemTotalAmount.html(booking.calc[key].quantity > 0 ? currencySymbol + ' ' + functions.formatMoney(booking.calc[key].total, 2, ',', '.') : '');
            }
        });

        booking.total();
    },
    submit() {
        let totalGuestData = [];

        $.each(booking.calc, function(key, item) {
            if ( ! item.inCalc) {
                delete booking.calc[key];
            } else if (item.itemDefinitionId.categoryId.key == 'baseRate') {
                let $guestsPerProduct = $("[data-guests-parentId='" + item.calcId + "']");
                let guests = [];

                if ($guestsPerProduct.length) {
                    $guestsPerProduct.find('[data-guests]').each(function (index) {
                        let g = +$(this).data('guests');

                        let guestData = {
                            firstName : $(this).find("input[name='guestFirstName" + g + "']").val(),
                            lastName : $(this).find("input[name='guestLastName" + g + "']").val(),
                            birthDate : $(this).find("*[name='birthDateYear" + g + "']").length ? $(this).find("*[name='birthDateYear" + g + "']").val() + '-' + $(this).find("*[name='birthDateMonth" + g + "']").val() + '-' + $(this).find("*[name='birthDateDay" + g + "']").val() : null,
                            gender : $(this).find("*[name='gender" + g + "']").length ? $(this).find("*[name='gender" + g + "']").val() : null,
                        }

                        guests[index] = guestData;

                        let guestExists = totalGuestData.find(guest => JSON.stringify(guest) === JSON.stringify(guestData));
                        ! guestExists && totalGuestData.push(guestData);
                    });
                    booking.calc[key].guestsData = guests;
                }
                
                if (item.customTransfer) {
                    booking.calc[key].guestsData = totalGuestData;
                }
            }
        });

        booking.params.paymentType = booking.$payment.find("[name='paymentType']:checked").val() ? booking.$payment.find("[name='paymentType']:checked").val() : 'bankTransfer';
        
        let calculation = booking.calc.filter(item => item);
        booking.params.calc = JSON.stringify(calculation);
        booking.params.requestId = Math.floor(Math.random() * ((9999999 - 1000000) + 1) + 1000000);

        $.each(booking.params, function (key, param) {
            $('<input>').attr({
                type: 'hidden',
                name: key,
                value: param
            }).appendTo(booking.$form);
        });
    },
};